const PATCH_NOTES = [
  {
    title: `Versión ${process.env.VUE_APP_VERSION}`,
    date: '2026-10-21', // '21 de Octubre de 2026',
    changes: [
      {
        title: 'Avisos y noticias dentro de la aplicación',
        description: [
          'Se añade una barra de noticias con opciones para abrir los avisos y cerrarlos.'
        ]
      },
      {
        title: 'Nueva funcionalidad "Modo IA"',
        description: [
          'Se añade un diálogo para interactuar con un asistente de IA capaz de interactuar con los datos de la aplicación.'
        ]
      },
      {
        title: 'Integración con OCR IA',
        description: [
          'Se añade la integración con OCR IA como módulo configurable para clientes y empresas.',
          'Se habilita la carga de facturas recibidas mediante OCR IA, con validación de archivos y soporte para PGE.'
        ]
      },
      {
        title: 'Actualización del módulo "Aprobación de facturas"',
        description: [
          'Se incorporan flujos de aprobación que pueden vincularse a reglas para revisar facturas recibidas.',
          'Se añaden acciones para aprobar, rechazar o reasignar facturas, junto con filtros para localizar las pendientes de aprobación y las asignadas al turno del usuario.',
          'Se permite editar facturas recibidas durante el proceso de aprobación.'
        ]
      },
      {
        title: 'Mejoras en las opciones de emisión y carga de facturas',
        description: [
          'Se agrupan las opciones "Emitir" y "Subir factura" en un menú común, con opciones para facturas emitidas, recibidas y Veri*Factu.',
          'Se adapta la navegación de este menú a dispositivos móviles.'
        ]
      },
      {
        title: 'Mejora en plantillas de generación de facturas en PDF y en la emisión',
        description: [
          'Se agrega la opción de sustituir, en el documento pdf, el IRPF por una retención personalizada incluyendo "** Nombre de la retención **" en el nodo "InvoiceAdditionalInformation" del Facturae.',
          'En la interfaz de emisión, se agrega el nombre registrado en InvoiZE del IRPF utilizado en el nodo "InvoiceAdditionalInformation" con la sintaxis correspondiente.'
        ]
      },
      {
        title: 'Mejoras en el asistente de Aída',
        description: [
          'Se incorpora la opción de solicitar/realizar una llamada para obtener soporte.'
        ]
      },
      {
        title: 'Mejoras en la configuración de clientes y usuarios',
        description: [
          'Se añade una opción para definir si los usuarios nuevos se crean activos por defecto.'
        ]
      },
      {
        title: 'Mejora en las validaciones de datos fiscales y de contacto',
        description: [
          'Se mejoran las validaciones del NIF/CIF de empresas y se añaden avisos de validación en los datos de contacto.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.5.6',
    date: '2026-09-01', // '1 de Septiembre de 2026',
    changes: [
      {
        title: 'Nuevo módulo "Generar enlace de cobro"',
        description: [
          'Para facturas emitidas se añade nueva acción "Generar enlace de cobro".',
          'Nuevo email personalizable para enviar el enlace de cobro.',
        ]
      },
      {
        title: 'Mejora en plantillas de generación de facturas en PDF',
        description: [
          'Optimización de decimales para el precio unitario y el total de cada producto.',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.5.5',
    date: '2026-08-10', // '10 de Agosto de 2026',
    changes: [
      {
        title: 'Nueva funcionalidad de dashboard financiero',
        description: [
          'Se añade nueva vista financiera con activación mediante grupos.',
          'Posibilidad de ver el desglose de facturas emitidas y recibidas.',
          'Nueva vista con el estado de impuestos y Veri*Factu.',
          'Posibilidad de filtrar por periodo, fecha y empresa.',
          'Se agrega panel de alertas y notificaciones.',
        ]
      },
      {
        title: 'Mejora de importación de facturas con excel',
        description: [
          'Se añade la opción método de pago y forma de envío.',
        ]
      },
      {
        title: 'Mejora en interfaz de emisión',
        description: [
          'Se agrega el campo Cesionario en el método de pago.',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.5.4',
    date: '2026-05-11', // '11 de Mayo de 2026',
    changes: [
      {
        title: 'Mejoras en la plantilla Veri*Factu',
        description: [
          'Se agrega el campo DIR3 o DIRe del receptor en las plantillas Veri*Factu',
        ]
      },
      {
        title: 'Mejoras en la descarga de facturas',
        description: [
          'Se agregan la acción para descarga masiva de facturas recibidas y emitidas',
        ]
      },
      {
        title: 'Nuevos filtros en la sección Clientes/Proveedores',
        description: [
          'Se agregan los filtros "Rol del contacto"',
        ]
      },
      {
        title: 'Nueva opción de configuración en una Sede',
        description: [
          'Para el rol Cesionario se agrega un campo Cláusula de cesión',
        ]
      },
      {
        title: 'Nueva opción de configuración general en Cliente',
        description: [
          'Se agrega una opción para adjuntar solo PDF en facturas enviadas por email',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.5.3',
    date: '2026-03-12', // '12 de Marzo de 2026',
    changes: [
      {
        title: 'Nuevos filtros en las secciones de facturas',
        description: [
          'Se agregan los filtros de "Código cliente receptor/emisor", "Fecha de vencimiento" (Solo emitidas) y "SEPA" (Solo emitidas).',
        ]
      },
      {
        title: 'Columna de Reporting activo en Mis empresas',
        description: [
          'Se añade una nueva columna, con su filtro correspondiente, para visualizar los diferentes reportings que tiene activos la empresa.',
          'Los diferentes reportings disponibles son: Veri*Factu y TicketBAI-Batuz.',
        ]
      },
      {
        title: 'Mejoras en la interfaz de emisión',
        description: [
          'Se realizan validaciones de las configuraciones necesarias para la emisión con Veri*Factu o a Puntos Generales de Entrada (PGE), en el paso de intervinientes.',
          'Se implementa un diálogo para redirigir a la configuración necesaria.',
          'En el paso de pago, se permite modificar la fecha de vencimiento de la factura para los pagos que no son al contado.',
        ]
      },
      {
        title: 'Mejoras en la subida de facturas',
        description: [
          'Se implementan validaciones más estrictas de la configuración de firma para la subida de facturas emitidas con Veri*Factu activo o a un Punto General de Entrada (PGE).',
          'Se incluye un diálogo para redirigir a la configuración necesaria.',
          'Se añade un botón de descarga, para poder descargar la plantilla Excel (xlsx de importación Zerocoma).'
        ]
      },
      {
        title: 'Modificaciones en las acciones de las facturas',
        description: [
          'Se reordenan las acciones de los grids de facturas, de tal manera que las acciones sobre los grupos se colocan debajo de las acciones de estado.',
          'Se bloquea la acción de "Eliminar" para todas las facturas emitidas que no sean presupuestos, proformas y no estén duplicadas.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.5.2',
    date: '2026-02-11', // '11 de Febrero de 2026',
    changes: [
      {
        title: 'Mejoras en la configuración de plantillas pdf',
        description: [
          'Se añade la posibilidad de incluir un pie de página personalizado al final de la última página* de las facturas generadas.',
        ]
      },
      {
        title: 'Datos registrales de empresa',
        description: [
          'Nueva sección de configuración dentro del detalle de una empresa, para rellenar los datos registrales:',
          'Libro, Registro Mercantil, Hoja, Folio, Sección, Tomo y Otros datos.',
          'Se incluyen estos datos en los facturaes y en los pdf generados desde el menú "emitir".'
        ]
      },
      {
        title: 'Mejoras en la interfaz de emisión',
        description: [
          'En el paso de líneas, se admiten las cantidades con decimales cuando la unidad de medida es "UNIDADES".',
        ]
      },
      {
        title: 'Histórico de Registros Veri*Factu',
        description: [
          'Nueva sección para consultar y visualizar el histórico de los registros.',
        ]
      },
      {
        title: 'Cambios en los correos de aviso',
        description: [
          'Los correos de aviso de "envío de factura" y de "envío de autofactura" ya no envían los ficheros como adjunto.',
          'Se incluye en el email, un enlace de descarga para poder descargar los ficheros de la factura.',
          'Se añade el tag "Enlace de Descarga" en la personalización de las plantillas de "envío de factura" y de "envío de autofactura" para poder incluir dicho enlace.'
        ]
      },
      {
        title: 'Personalización de fichero ZIP en correo',
        description: [
          'Nuevo módulo que añade dos configuraciones en la configuración general de un cliente.',
          'Habilitar el envío adjunto de los ficheros de la factura en los avisos de "envío de factura" y de "envío de autofactura".',
          'Personalizar el nombre del fichero/ZIP descargado desde los avisos de "envío de factura" y de "envío de autofactura".',
        ]
      },
      {
        title: 'Descargar solo adjuntos principales',
        description: [
          'Restringir la descarga de ficheros únicamente a los documentos principales de la factura desde los avisos de "envío de factura" y de "envío de autofactura".'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.5.1',
    date: '2026-01-21', // '21 de Enero de 2026',
    changes: [
      {
        title: 'Cambios en las plantillas pdf',
        description: [
          'Se actualizan los aspectos de las plantillas pdf.',
          'Se cambia el tratamiento de los logos, para admitir el rescalado automático de los logos al tamaño requerido sin deformar los logos.',
        ]
      },
      {
        title: 'Mejoras en la configuración de plantillas pdf',
        description: [
          'Se mejora la personalización de logo en la configuración de plantillas pdf, para permitir el recorte del logo de forma opcional.',
        ]
      },
      {
        title: 'Mejoras en la interfaz de emisión',
        description: [
          'En el paso \'líneas de factura\' se ha habilitado la opción de modificar el precio unitario de los productos.',
          'Solo para la factura que se está emitiendo en el momento de la modificación.',
        ]
      },
      {
        title: 'Nuevas acciones de Registros Veri*Factu',
        description: [
          'Se añade la posibilidad de archivar los registros en estado correctos, aceptados con errores o incorrectos',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.5.0',
    date: '2025-12-17', // '17 de Diciembre de 2025',
    changes: [
      {
        title: 'Nueva funcionalidad SEPA',
        description: [
          'Se agrega la generación de ficheros de cobros domiciliados en formato SEPA según normativa europea de pagos',
        ]
      },
      {
        title: 'Mejoras en la interfaz de emisión',
        description: [
          'En el paso \'forma de pago\' se ha mejorado la selección del método de pago',
        ]
      },
      {
        title: 'Nuevas acciones de Registros Veri*Factu',
        description: [
          'Se añade la posibilidad de asignar grupos para registros',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión v.7.4.0',
    date: '2025-10-8', // '8 de Octubre de 2025',
    changes: [
      {
        title: 'Nueva funcionalidad de recargo de equivalencia',
        description: [
          'Se añade la posibilidad de incluir recargo de equivalencia en los siguientes apartados:',
          '- Grid, filtros, búsquedas, creación y detalle de Impuestos (Solo para impuestos con tipo IVA).',
          '- Creación de primer impuesto en la creación de productos.',
          '- Detalle de Cliente/Proveedor.',
        ]
      },
      {
        title: 'Mejoras en la interfaz de emisión',
        description: [
          'Se añade la opción de habilitar recargo de equivalencia para la factura',
          'Nueva sección con los tipos de exenciones a nivel global de factura',
        ]
      },
      {
        title: 'Mejoras en la configuración de empresa',
        description: [
          'Se separa la configuración de Firma Delegada a la sección de \'Configuración factura electrónica\'',
          'Se añade la opción de añadir un certificado desde la sección \'Configuración factura electrónica\'',
          'Se renombra el menú de configuración \'Reporte Hacienda\' a \'Envío Verifactu/TicketBAI\'',
          'Se establecen valores por defecto para la configuración de envío Veri*Factu'
        ]
      },
      {
        title: 'Nuevas acciones de Registros Veri*Factu',
        description: [
          'Posibilidad de subsanar ciertos errores en registros incorrectos',
        ]
      },
      {
        title: 'Mejoras en la generación de facturas en pdf',
        description: [
          'Se habilita la posibilidad de configurar la posición en la que se insertará el QR de Veri*Factu [Izquierda, Centro, Derecha].',
          'Se añaden dos nuevos tipos de plantillas: \'Plantilla Verifactu con QR a la izquierda\' y \'Plantilla Verifactu con QR a la derecha\''
        ]
      },
      {
        title: 'Cambios en la sección de \'Cuentas Bancarias\'',
        description: [
          'Se añade el identificador de mandato (Solo para cuentas bancarias de Cliente/Proveedor).',
          'Se agrega esta sección a la configuración de empresas (Ahora está en Cliente/Proveedor y en Empresas).'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.3.0',
    date: '2025-10-8', // '8 de Octubre de 2025',
    changes: [
      {
        title: 'Optimización del flujo de altas',
        description: [
          'Nuevo flujo para la creación de empresas, certificados, productos y sociedades',
        ]
      },
      {
        title: 'Mejoras en la configuración de empresa',
        description: [
          'En el detalle se añade la posibilidad de configurar Firma Delegada',
          'Los submenús para configuración Veri*Factu y TicketBAI se agrupan en \'Reporte Hacienda\'',
          'Se añade opción para activación de Veri*Factu y TicketBAI',
          'Se añade personalización de plantillas a nivel de empresa'
        ]
      },
      {
        title: 'Nuevas funcionalidades de Usuario',
        description: [
          'Posibilidad de activación de usuarios',
          'Se añaden nuevas acciones para \'Resetear doble factor\' y \'Reenviar correo para cambio de contraseña\'',
        ]
      },
      {
        title: 'Mejora de Webhooks',
        description: [
          'Se habilita el tipo de autenticación para \'Token\' y \'Usuario y contraseña\'',
          'Se añaden nuevos tipos de subscripción para Veri*Factu y SOAPFault AEAT'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.2.0',
    date: '2025-09-18', // '18 de Septiembre de 2025',
    changes: [
      {
        title: 'Nuevas funcionalidades de Facturas',
        description: [
          'Se añade funcionalidad de rectificar facturas emitidas.',
          'Se añade la funcionalidad para emitir facturas de forma recurrente.'
        ]
      },
      {
        title: 'Mejoras en la Interfaz de emisión',
        description: [
          'Se añade la posibilidad de emitir proformas, presupuestos y facturas simplificadas.',
          'Se añaden opciones para incluir observaciones a nivel de línea de factura.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.1.1',
    date: '2025-07-02', // '02 de Julio de 2025',
    changes: [
      {
        title: 'Mejoras en la Interfaz de emisión',
        description: [
          'Se añade la opción de crear sociedades, sedes, centros administrativos, IRPFs y productos desde su paso correspondiente sin interrumpir la emisión.',
          'Se añade la funcionalidad de auto-selección del emisor de una factura si solo se tiene una empresa disponible.',
          'Se abre el diálogo de añadir producto automáticamente cuando no hay líneas de factura.'
        ]
      },
      {
        title: 'Mejoras Veri*Factu',
        description: [
          'Se añade un nuevo apartado de configuración para integración con Veri*Factu a nivel de empresa.',
          'Se añade la opción de subir registros Veri*Factu manualmente desde el menú de "Subir facturas".'
        ]
      },
      {
        title: 'Mejoras en las vistas de tabla',
        description: [
          'Se añade la conservación de la selección entre páginas.',
          'La selección será limpiada en caso de aplicación de filtros, navegación o recarga de la página.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.1.0',
    date: '2025-06-05', // '05 de Junio de 2025',
    changes: [
      {
        title: 'Mejoras en la Interfaz de emisión',
        description: [
          'Se añade la opción de contraer el resumen de la factura emitida.',
        ]
      },
      {
        title: 'Nueva funcionalidad de APIKeys',
        description: [
          'Se añade la opción de tener tokens para la API de larga caducidad',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 7.0.0',
    date: '2025-05-09', // '09 de Mayo de 2025',
    changes: [
      {
        title: 'Nueva funcionalidad de Multiidioma',
        description: [
          'Se añaden idiomas \'Inglés\', \'Francés\', \'Alemán\', \'Catalán\', \'Gallego\' y \'Euskera\'.',
        ]
      },
      {
        title: 'Cambio en Agenda',
        description: [
          'Agenda cambia de nombre a \'Sociedades\'.',
          'Se añade a Sociedades los apartados \'Empresas vinculadas\' y \'Histórico\'.',
          'Se añade a Sedes los apartados \'Email de contacto\' y \'Cuentas bancarias\'.',
        ]
      },
      {
        title: 'Nuevo módulo de Interfaz de emisión de facturas',
        description: [
          'Es necesario tener activado el módulo \'Emisión de facturas\' para un correcto funcionamiento.',
          'Se añade nueva funcionalidad para emitir facturas por pasos.',
          'Se añaden los pasos de emisión de facturas \'Intervinientes\', \'Detalle\', \'Líneas\', \'Pago\' y \'Adjuntos\'.',
          'Se añade resumen de la factura.',
        ]
      },
      {
        title: 'Nuevo módulo de Veri*Factu',
        description: [
          'Se añaden registros de Veri*Factu.',
          'Se añaden los estados \'Correcto\', \'Aceptado con errores\', \'Incorrecto\' y \'Pendiente de notificar\'.',
          'Se añade detalle de registros.',
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 6.1.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Configuración Autenticación AAD/SAML2',
        description: [
          'Módulo de autenticación con integración a través de Azure Active Directory',
          'Módulo de autenticación con integración a través del estándar SAML2',
          'Inicio de sesión dinámica en función del tipo de autenticación del usuario'
        ]
      },
      {
        title: 'Nuevos módulos de Webhooks',
        description: [
          'Se añaden dos nuevos modulos para los eventos de las Facturas Emitidas y Recibidas',
          'Se añade nueva vista de configuracion de los Webhooks. Integracion con Microsoft Teams o Integracion personalizada (Zerocoma)'
        ]
      },
      {
        title: 'Nuevo módulo de TicketBAI-Batuz',
        description: [
          'Se añade un apartado de configuración para la integración a TicketBAI-Batuz.'
        ]
      },
      {
        title: 'Cambio en el flujo de \'Envío Externo\'',
        description: [
          'Se elimina el estado \'Envío Externo\'.',
          'Las facturas que se encuentren en este estado, pasarán al estado \'Enviada\'.',
          'Las facturas con pge \'Envío Externo\' ahora pasan por el flujo normal de facturas.'
        ]
      },
      {
        title: 'Eliminación de acciones en las facturas emitidas',
        description: [
          'Se eliminan todas las acciones \'Pasar a\' de las facturas en estado \'Sin Enviar\'.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 6.0.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Nueva funcionalidad de Agenda',
        description: [
          'Se añade un apartado en el que se pueden agregar distintos tipos de contactos.'
        ]
      },
      {
        title: 'Nueva funcionalidad de Validación',
        description: [
          'Se cruzan los ficheros de la factura con sus esquemas y se comprueban los adjuntos de forma previa a la subida de la factura.'
        ]
      },
      {
        title: 'Nueva funcionalidad de Plantillas',
        description: [
          'Se agrega una nueva configuración con valores por defecto para la creación de nuevas empresas y nuevos grupos.'
        ]
      },
      {
        title: 'Nuevo módulo de Autofactura',
        description: [
          'Se añade la opción de subir y emitir autofacturas desde la plataforma.'
        ]
      },
      {
        title: 'Nuevo módulo de Agrupaciones',
        description: [
          'Se añade una sección para crear conjuntos de entidades (Empresas, Proveedores o Clientes) y utilizarlos posteriormente en filtros y otras partes del aplicativo.'
        ]
      },
      {
        title: 'Nuevo módulo de Personalización',
        description: [
          'Se añaden diferentes opciones de personalización como: Logos, colores, cuenta SMTP y emails personalizados.'
        ]
      },
      {
        title: 'Nuevo módulo de Plantilla PDF',
        description: [
          'Se añade la opción de generar una factura pdf a partir del facturae en base a una plantilla y configuración establecida.'
        ]
      },
      {
        title: 'Nuevo producto de EdasInvoiZEFiles',
        description: [
          'Se añade la opción de subir facturas con sus adjuntos desde el servicio EdasInvoiZEFiles.'
        ]
      },
      {
        title: 'Posibilidad de subir facturas recibidas',
        description: [
          'Se añade la opción de subir facturas recibidas manualmente desde el menú de "Subir facturas".'
        ]
      },
      {
        title: 'Reorganización de filtros',
        description: [
          'Se reorganizan los filtros de las secciones relativas a facturas.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 5.2.2',
    date: '2024-03-20', // '20 de Marzo de 2024',
    changes: [
      {
        title: 'Corrección de textos',
        description: [
          'Se corrigen algunos textos en la validación del licenciamiento.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Se corrige la desaparición de la columna "Detalle" de las tablas relacionadas con las facturas.'
        ]
      },
    ]
  },
  {
    title: 'Versión 5.2.1',
    date: '2024-03-18', // '18 de Marzo de 2024',
    changes: [
      {
        title: 'Actualización de textos',
        description: [
          'Se actualizan algunos textos dentro de la aplicación para una mayor descriptividad.'
        ]
      },
      {
        title: 'Mejoras de eficiencia',
        description: [
          'Se aplican mejoras en la eficiencia de los selectores dentro de la aplicación.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 5.2.0',
    date: '2024-02-27', // '27 de Febrero de 2024',
    changes: [
      {
        title: 'Ampliado los esquemas admitidos para emisión',
        description: [
          'Se añade compatibilidad y validación de otros esquemas a parte del Facturae.'
        ]
      },
      {
        title: 'Firmado y recuperación de facturas para envío externo',
        description: [
          'Se añade el Punto General de Entrega Envío externo, útil para realizar únicamente el firmado de las facturas para enviar de forma externa.'
        ]
      },
      {
        title: 'Nuevo Punto General de Entrega Cataluña (e-Fact)',
        description: [
          'Se añade el Punto General de Entrega e-Fact para el envío de facturas a las administraciones de cataluña no adheridas a FACe.',
          'Consulte las administraciones adheridas en #link:eFact#.'
        ],
        links: [
          {
            tag: 'eFact',
            linkName: 'e-Fact',
            url: 'https://efact.aoc.cat/bustia/receiver/list.htm'
          }
        ]
      },
      {
        title: 'Recuperación de ficheros enviados',
        description: [
          'Si la factura a enviar ha sufrido alguna alteración para el envío al Punto General de Entrega, se almacenará como documento relacionado de la factura.'
        ]
      },
      {
        title: 'Firma de terceros',
        description: [
          'Todos aquellos Facturaes que se firmen a través del certificado de Colaborador Social, se les incluirá nuestros datos como terceros en el nodo ThirdParty del Facturae.'
        ]
      },
      {
        title: 'Corrección de errores',
        description: [
          'Errores relacionados con los transformadores ya existentes.',
          'Corrección de errores menores.'
        ]
      },
    ]
  },
  {
    title: 'Versión 5.1.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nueva funcionalidad de Dashboard: Nueva vista con información útil sobre las facturas y el licenciamiento.'
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Correcciones menores.',
        ]
      },
    ]
  },
  {
    title: 'Versión 5.0.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nueva funcionalidad de Distribuidor: Gestiona múltiples clientes como distribuidor con provisionamiento con bolsa de licenciamiento o de forma libre.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 4.2.0',
    date: '2023-10-30', // '30 de Octubre de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nueva funcionalidad de Grupos. Las etiquetas ahora son grupos, los grupos mantienen la funcionalidad de etiquetas y añaden: gestión de usuarios, gestión ampliada de facturas.',
          'Actualización del perfil de usuario con información sobre los grupos a los que pertenece.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 4.1.0',
    date: '2023-08-11', // '11 de Agosto de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Incorporación de recepción de facturas en los PGE FACe y FACeB2B.',
          'Nuevos módulos disponibles para contratar. Puede consultarlos en la sección de configuración general.'
        ]
      },
    ]
  }, 
  {
    title: 'Versión 4.0.0',
    date: '2023-05-24', // '24 de Mayo de 2023',
    changes: [
      {
        title: 'Lanzamiento',
        description: [
          // 'Gestión y administración de ...',
        ]
      },
    ]
  }, 
  // {
  //   title: 'Versión 2.11.0',
  //   date: '2022-12-13', // '13 de Diciembre de 2022',
  //   changes: [
  //     {
  //       title: 'Nuevas características',
  //       description: [
  //         'Nuevo tipo de usuario: Usuario Consulta. Usuario para consulta y revisión de datos, similar al rol "Usuario" con restricciones a la hora de realizar acciones sobre facturas, solo puede visualizarlas y descargar el contenido de estas.',
  //         'Nueva funcionalidad de edición y eliminación de Metadatos Adicionales de una factura, accesible en el detalle de las facturas.',
  //         'Se ha añadido la opción de exportar un fichero excel de los errores detectados, desde el cuadro de diálogo de los detalles de errores del Dashboard.',
  //         'Se ha añadido una nueva opción de exportar un fichero excel del histórico completo de los errores detectados, de una empresa y una sede concretos, desde el cuadro de diálogo de los detalles de errores del Dashboard.',
  //         'Al seleccionar la acción "Excluir organismo asociado" desde la vista de facturas, se ha añadido la opción de excluir dicho organismo a todas las empresas del cliente, además de mantenerse la opción por defecto de solo excluir el organismo a la empresa asociada a esa factura.',
  //       ]
  //     },
  //     {
  //       title: 'Errores corregidos',
  //       description: [
  //         'Corregido error en la subida de facturas manualmente.',
  //         'Correciones en textos y descripciones.',
  //         'Otras correciones menores',
  //       ]
  //     },
  //   ]
  // }, 
]

export {
  PATCH_NOTES
}
